import ctas from "./ctas";
import mediaQueries from "./media-queries";

const header = {
  fontFamily: "JWSansBold",
  fontSize: "22px",
  letterSpacing: "2px",
  textAlign: "center",
  textTransform: "uppercase",
  [mediaQueries.tablet]: {
    fontSize: "44px",
    letterSpacing: "2px"
  }
};

const errorContainer = {
  padding: "17px 25px 22px 25px",
  margin: "0 auto",
  maxWidth: "452px"
};

const errorCopy = {
  fontFamily: "JWSansBook",
  letterSpacing: "2.05px",
  lineHeight: 1.33,
  maxWidth: "60%",
  margin: "0 auto",
  [mediaQueries.tablet]: {
    maxWidth: "80%"
  }
};

const errorTitle = {
  ...errorCopy,
  textTransform: "uppercase",
  fontSize: "13px",
  marginBottom: "10px"
};

const errorMessage = {
  ...errorCopy,
  fontSize: "12px"
};

const cta = {
  ...ctas.initial,
  marginTop: "30px",
  maxWidth: "205px"
};

export default {
  header,
  errorContainer,
  errorTitle,
  errorMessage,
  cta
};



// WEBPACK FOOTER //
// ./src/styles/error.js